import type { Routes } from '../../shares/types';
import { BadgeBasic } from './basic';

export const BADGE_ROUTES: Routes = {
	badge: {
		basic: BadgeBasic,
	},
};
